import { render, staticRenderFns } from "./CreateRoomLog.vue?vue&type=template&id=6f360098&lang=pug&"
import script from "./CreateRoomLog.vue?vue&type=script&lang=ts&"
export * from "./CreateRoomLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports